import { reactive } from "vue";

// Options added via the Select "+ create" action live in the component
// instance, so navigating away (the select unmounts) would lose them. This
// module-level cache keeps them per field+payload for the session, so a select
// that re-mounts (e.g. wizard step navigation) restores its created options.
const cache = new Map();

export function useCreatedOptionsStore(key) {
  if (!key) return reactive([]);
  if (!cache.has(key)) {
    cache.set(key, reactive([]));
  }
  return cache.get(key);
}

// Drop a field's created options (e.g. once they have been persisted for real).
export function clearCreatedOptionsStore(key) {
  cache.delete(key);
}
